import { TableConfig } from "@/types";
import { DateUtils } from "@/helpers/DateUtils";

export const quoteTableConfig: TableConfig = {
  body: [
    {
      id: "quoteNumber",
      title: "# cotización",
      source: "$record.custom_attributes.quote_number",
      component: "card-info-row",
      fallback: "-",
    },
    {
      id: "product",
      title: "Producto",
      source: "$record.process.name",
      component: "card-info-row",
      fallback: "-",
    },
    {
      id: "applicantsName",
      title: "Nombre del cliente",
      source: "$record.applicants_name",
      component: "card-info-row",
      fallback: "-",
      formatter: (value) => (value ? String(value).toUpperCase() : "-"),
    },
    {
      id: "identificationType",
      title: "Tipo de identificación",
      source: "$record.custom_attributes.identification_type.detalle",
      component: "card-info-row",
      fallback: "-",
    },
    {
      id: "identificationNumber",
      title: "Número de identificación",
      source: "$record.custom_attributes.identification_number",
      component: "card-info-row",
      fallback: "-",
    },
    {
      id: "quoteStatus",
      title: "Estado",
      source: "$record.grouped_tags.quote_status.0.name",
      component: "card-info-row",
      type: "vue-status-badge-v2",
      formatter: (value) => ({ label: value ?? "-", color: "color" }),
    },
    {
      id: "createdAt",
      title: "Fecha de creación",
      source: "$record.created_at",
      component: "card-info-row",
      fallback: "-",
      formatter: (value) => (value ? DateUtils.formatDateTime({ date: value }) : "-"),
    },
    {
      id: "createdBy",
      title: "Usuario",
      source: "$record.created_by.name",
      component: "card-info-row",
      fallback: "-",
    },
  ],
  actions: [
    {
      id: "delete",
      label: "Eliminar",
      icon: "trash",
      classes: "btn btn-secondary",
      event: "delete-record",
      conditions: [{ type: "can", values: [["applications-management.applications.delete"]] }],
    },
    {
      id: "continue",
      label: "Continuar",
      classes: "btn btn-danger",
      icon: "pen",
      to: { name: "EditCurrentStep", params: { id: "$record.id" } },
      conditions: [
        {
          type: "can",
          values: [["applications-management.applications.read"], ["applications-management.applications.update"]],
        },
        {
          type: "notIn",
          values: [
            "$record.grouped_tags.quote_status.0.id",
            [
              process.env.VUE_APP_FINISHED_QUOTE_STATUS_TAG as string,
              process.env.VUE_APP_DIGITAL_ACCEPTANCE_QUOTE_STATUS_TAG as string,
              process.env.VUE_APP_ACCEPTED_QUOTE_STATUS_TAG as string,
            ],
          ],
        },
      ],
    },
    {
      id: "view",
      label: "Ver",
      classes: "btn btn-danger",
      icon: "eye",
      to: { name: "ReadStep", params: { id: "$record.id", stepId: "0001" } },
      conditions: [
        { type: "can", values: [["applications-management.applications.read"]] },
        {
          type: "in",
          values: [
            "$record.grouped_tags.quote_status.0.id",
            [
              process.env.VUE_APP_FINISHED_QUOTE_STATUS_TAG as string,
              process.env.VUE_APP_DIGITAL_ACCEPTANCE_QUOTE_STATUS_TAG as string,
              process.env.VUE_APP_ACCEPTED_QUOTE_STATUS_TAG as string,
            ],
          ],
        },
      ],
    },
  ],
};
